const SyncroConnect = () => import('@/views/account/integrations/syncro/syncro-connect-view.vue');
const SyncroManage = () => import('@/views/account/integrations/syncro/syncro-manage-view');

import store from '@/stores/index';

import SyncroMappingRoutes from '@/routes/integrations/syncro/mapping';
import SyncroImportRoutes from '@/routes/integrations/syncro/import';

export default [
    {
        path: '/Integrations/Syncro/Manage',
        name: 'SyncroManage',
        component: SyncroManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Syncro Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage',
        name: 'ClientSyncroManage',
        component: SyncroManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Syncro Integration'
        }
    },
    {
        path: '/Integrations/Syncro/Manage/Connection',
        name: 'SyncroConnect',
        component: SyncroConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Syncro Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Connection',
        name: 'ClientSyncroConnect',
        component: SyncroConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Syncro Integration'
        }
    },
    ...SyncroMappingRoutes,
    ...SyncroImportRoutes
]